import BaseService from '@/network/base-service'

class CEPService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/apoio/consultas`)
  }
  buscarCEP (cep) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/apoio/consultas/endereco?cep=${cep}`, { method: 'GET' })
  }
}

export default new CEPService()
